import { useMutation, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useEffect, useState } from 'react';
import { AgencyDetails, InstallerDetails, RegisterInvoicePortalUserErrorReason, RegisterInvoicePortalUserInput, RegisterInvoicePortalUserResponse } from '../../__generated__/pge-types';
import useFormState from '../useFormState';
import registerFormValidationRules, {
    RegisterFormModel,
  } from '../../components/invoice-payment-portal/auth/registerFormValidation.rules';
import useContentMgmt from '../useContentMgmt';
import microcopyGroupIds from '../../components/pge-plus-common/microcopyGroupIds';
import useWrapWithLoader from '../useWrapWithLoading';
import { parsePhoneNumber } from '../../util/format';
import useUtil from './useUtil';
  

export const getInstallerList = gql`
  query GetInstallerList {
    getInstallerList {
      installerName
      personId
    }
  }
`;

export const registerInvoicePaymentUserMutation = gql`
  mutation RegisterInvoicePortalUser($payload: RegisterInvoicePortalUserInput!) {
    registerInvoicePortalUser(payload: $payload) {
      isSuccess
      errorReason
    }
  }
`;

export const approveInvoicePortalUserRegistrationMutation = gql`
  mutation ApproveInvoicePortalUserRegistration(
    $payload: InvoicePortalApproveUserRegistrationInput!
  ) {
    approveInvoicePortalUserRegistration(payload: $payload) {
      isSuccess
      errorReason
    }
  }
`;

export const rejectInvoicePoratlUserUserRegistrationMutation = gql`
  mutation RejectInvoicePortalUserRegistration(
    $payload: InvoicePortalRejectUserRegistrationInput!
  ) {
    rejectInvoicePortalUserRegistration(payload: $payload) {
      isSuccess
    }
  }
`;
const defaultRegisterFormState: RegisterFormModel = {
   firstName: '',
   installerPersonId: '',
   lastName:'',
   phoneNumber:'',
   email:'',
   pinId:''
};

export const useInvoicePaymentRegistration = () => {
    const { content } = useContentMgmt(
        microcopyGroupIds.INVOICE_PAYMENT_SIGN_IN,
      );
      const { wrapWithLoader } = useWrapWithLoader();
      const { setErrorNotification } = useUtil();
      
    const [registerInvoicePortalUser] = useMutation<{
        registerInvoicePortalUser: RegisterInvoicePortalUserResponse;
    }>(registerInvoicePaymentUserMutation);
   const [installerList, setInstallerListList] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);
  const registerForm = useFormState(defaultRegisterFormState, {
      validate: registerFormValidationRules,
      validationContext: {
       content
      },
    });
  const { loading: installerListLoading, data: installerData } =
    useQuery(getInstallerList);
    
    useEffect(() => {
        if (installerData && installerData.getInstallerList?.length) {
          const sortedInstallerList = [...installerData.getInstallerList]
            .sort((a: InstallerDetails, b: InstallerDetails) =>
              a.installerName.localeCompare(b.installerName),
            )
            .map((installer: InstallerDetails) => ({
              label: installer.installerName,
              value: installer.personId,
            }));
    
            setInstallerListList(sortedInstallerList);
        }
      }, [installerData]);

      const handleSubmit = wrapWithLoader(async (data: RegisterFormModel) => {
        const registerInput: RegisterInvoicePortalUserInput = {
          installerPersonId: data.installerPersonId,
          phoneNumber: '+1' +parsePhoneNumber(data.phoneNumber),
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          workId: data.pinId,
        };
    
        const { data: registerData } = await registerInvoicePortalUser({
          variables: {
            payload: registerInput,
          },
        });
        if (registerData?.registerInvoicePortalUser?.isSuccess) {
            setErrorNotification(
            true,
            content.get('REGISTERATION_FORM_SUBMITTED'),
            'success',
          );
          window.scrollTo(0, 0);
          registerForm.reset(defaultRegisterFormState);
    
        } else if (
          registerData?.registerInvoicePortalUser?.errorReason ===
          RegisterInvoicePortalUserErrorReason.EmailAlreadyRegistered
        ) {
            setErrorNotification(
                true,
                content.get('EMAIL_ALREADY_REGISTERED'),
                'error',
              );
           
        }
      });
    

  return {
    installerListLoading,
    installerList,
    registerForm,
    content,
    handleSubmit
  };
};
